import { SecuredKoppClient } from '../../../Core/Api/Kopp/SecuredKoppClient';
import ITableDataFetcher from '../../Forms/DataGrid/SimpleTable/Models/ITableDataFetcher';
import ITableDataResponse from '../../Forms/DataGrid/SimpleTable/Models/ITableDataResponse';
import {
  GetCustomerTrackedBolReportRequest,
  GetFilteredTrackedBolForLoggedInUserQueryRequest,
  IGetFilteredTrackedBolForLoggedInUserQueryRequest,
  ITrackedBol,
  TrackedBol,
  UpdateTrackedBolSupplementaryInfoRequest,
  UpdateTrackedBolSupplementaryInfoResponse,
} from '../../../Core/Api/Kopp/Api';
import TableRequest from 'Core/TableUtility/Models/TableRequest';

export default class TrackedBolHandler implements ITableDataFetcher<TrackedBol> {
  props: any;
  constructor(props) {
    this.props = props;
  }

  GetData(
    tableRequest: IGetFilteredTrackedBolForLoggedInUserQueryRequest
  ): Promise<ITableDataResponse<TrackedBol>> {
    return this.GetTrackedBol(tableRequest);
  }

  GetTrackedBol(request: IGetFilteredTrackedBolForLoggedInUserQueryRequest) {
    const client = new SecuredKoppClient();
    client.showLoading = false;
    client.handleGeneralError = true;
    return client.getFilteredTrackedBolForLoggedInUser(
      new GetFilteredTrackedBolForLoggedInUserQueryRequest(request)
    );
  }

  UpdateTrackedBol(model: ITrackedBol) {
    const client = new SecuredKoppClient();
    client.showLoading = true;
    client.handleGeneralError = true;
    let request = new UpdateTrackedBolSupplementaryInfoRequest({
      trackedBolSupplementaryInfo: model,
    });
    return client.updateTrackedBolSupplementaryInfo(request);
  }

  GenerateReport(tableRequest: TableRequest) {
    const client = new SecuredKoppClient();
    const request = new GetCustomerTrackedBolReportRequest(tableRequest);
    return client.getCustomerTrackedBolReport(request);
  }
}
